module.exports = __webpack_public_path__ + "static/media/background images.ddf2f6f1.png";